import React, { useEffect } from 'react';
import { IFeaturedImage } from '@/shared/types/existing-brands';
import Link from 'next/link';
import Image from 'next/image';
import './index.less';

interface IProps {
  title: string;
  table: IFeaturedImage;
  description: string;
}

const GrowSalesContent = ({ title, description, table: { link, width, height } }: IProps) => {
  const id = `#id_${title.split(' ').join('_')}`;

  useEffect(() => {
    const scrollEle = document.getElementById(id);
    scrollEle.scrollTo(700, 0);
  }, [id]);

  return (
    <div className="grow-sales-content">
      <div className="grow-sales-info">
        <h3>{title}</h3>
        <p>{description}</p>
        <Link href="/" className="learn-more">
          <p>Learn more</p>
          <Image width={12} height={12} src="/images/svg/arrow-right.svg" alt="arrow-right" />
        </Link>
      </div>
      <div className="table-container" id={id}>
        <Image width={width} height={height} src={link} alt={title} />
      </div>
    </div>
  );
};

export default GrowSalesContent;
